export default {
      id: "221,8=1,7+60+35+28,4+35+60+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#221,8=1,7+60+35+28,4+35+60+1,7",
      toString: function () {
        return this.url;
      }
    }